export default __webpack_public_path__ + "static/media/comment-dots.9b196958.svg";